<template>
  <div >
    <div class="bg"></div>
    <HomeTitle name="奖牌榜" info="Medal Tally"/>
    <Medal :isHome="isHome" :medalList="medalList" />
    <HomeTitle name="赛程" info="Schedule" :pbottom="true"/>
    <!-- <ScheduleCompetition :showNum="true" :showScheduleTop="false"/> -->
    <RecentMatch :showTitle="false" :agencyId="4" :pid="1316"/>
    <!-- 竞赛项目 -->
    <div class="project" :style="bgColor">
      <div class="p-left" >
        <template v-if="programAll.length<=4">
          <div :class="'p'+(index)" @click="handlepaogram(index)" v-for="(item,index) in programAll" :key="index">
            <div :class="'square'+(index)">{{item.title}}</div>
            <div :class="'triangle'+(index)"></div>
          </div>
        </template>
        <template v-if="programAll.length>4">
          <div :class="'p'+(index)" @click="handlepaogram(index)" v-for="(item,index) in programAll.slice(0,3)" :key="index">
            <div :class="'square'+(index)">{{item.title}}</div>
            <div :class="'triangle'+(index)"></div>
          </div>
          <div class="p3" @click="moreProgram">
              <div class="square3 ">查看更多</div>
              <div class="triangle3"></div>
            </div>
        </template>
      </div>
      <HomeTitle name="竞赛项目" info="Competition Events" :colorWhite="true"/>
      <MySwiper v-if="program.length>0" :noShowBg="true" :program="program"/>
    </div>
    <HomeTitle name="精彩锦集" info="Wonderful Collection"/>
    <div class="wonderful" @click="wonderfulDetail">
        <div class="w-left">
          <img :src="highlights[0].image" alt="">
          <div>{{ highlights[0].des }}</div>
        </div>
        <div class="w-right">
          <div class="w-right-item" style="margin-bottom:10px">
            <img :src="highlights[1].image" alt="">
            <div>{{ highlights[1].des }}</div>
          </div>
          <div class="w-right-item">
            <img :src="highlights[2].image" alt="">
            <div>{{ highlights[2].des }}</div>
          </div>
        </div>
    </div>
    <HomeTitle name="最美九龙坡" info="Beautiful Jiulongpo"/>
      <div class="beautiful" @click="BeautifulDetail">
        <div class="beau-item" v-for="(item,index) in beautifulList" :key="index" :class="index%4==3?'nomr':''" style="position: relative">
          <img :src="item.image" alt="">
          <div>{{item.des}}</div>
        </div>
      </div>
    <Footer />
  </div>
</template>

<script>
import HomeTitle from '@district/components/common/HomeTitle.vue'
import Medal from '@district/components/home/Medal.vue'
import MySwiper from '../../components/common/ProgramSwiper.vue'
import RecentMatch from '@comm/components/RecentMatch.vue'
import ScheduleCompetition from '../../components/common/ScheduleCompetition.vue'

export default {
  components: {
    HomeTitle,
    Medal,
    ScheduleCompetition,
    MySwiper,
    RecentMatch
  },
  data () {
    return {
      tabIndex:0,//竞赛项目index
      beautifulList:[
        {
          id:1,
          image:require('../../assets/image/home/3.png'),
          des: '重庆市九龙坡区第十二届运动会'
        },
        {
          id:2,
          image:require('../../assets/image/home/4.png'),
          des: '重庆市九龙坡区第十二届运动会'
        },
        {
          id:1,
          image:require('../../assets/image/home/5.png'),
          des: '重庆市九龙坡区第十二届运动会'
        },
        {
          id:1,
          image:require('../../assets/image/home/6.png'),
          des: '重庆市九龙坡区第十二届运动会'
        },
        {
          id:1,
          image:require('../../assets/image/home/7.png'),
          des: '重庆市九龙坡区第十二届运动会'
        },
        {
          id:1,
          image:require('../../assets/image/home/8.png'),
          des: '重庆市九龙坡区第十二届运动会'
        },
        {
          id:1,
          image:require('../../assets/image/home/9.png'),
          des: '重庆市九龙坡区第十二届运动会'
        },
        {
          id:1,
          image:require('../../assets/image/home/10.png'),
          des: '重庆市九龙坡区第十二届运动会'
        },
      ],
      highlights: [
        { id: 1, image: require('../../assets/image/home/big1.png'), des: '众多国际象棋选手展开激烈的角逐' },
        { id: 2, image: require('../../assets/image/home/1.png'), des: '绿荫场上的女运动员们'  },
        { id: 3, image: require('../../assets/image/home/2.png'), des: '各参赛队伍候场备战'  }
      ],
      medalList:[],
      rankParams:{
        pageSize:10,
        pageNum:1,
        programId:-1,
        agencyName:-1,
        title:-1,
      },
      // 最美九龙坡/精彩锦集请求参数
      highlightsParams: {
        agencyId: -1,
        pageNum: 1,
        pageSize: 3,
        typeId: 2
      },
      beautifulParams: {
        agencyId: -1,
        pageNum: 1,
        pageSize: 8,
        typeId: 1
      },
      isHome:true,
      programAll:[],
      program:[],
    }
  },
  mounted () {
    this.getSeriesGroup()
    this.getFindSeriesRankList()
    this.queryHighlights()
    this.queryBeautiful()
  },
  methods: {
    moreProgram (){
      this.$router.push({
        name: 'Project'
      })
    },
    handlepaogram (index) {
      console.log('handlepaogram0',index)
      this.tabIndex = index
      this.program=this.programAll[index].matchList
    },
    async getFindSeriesRankList (){
      try {
        let res =await this.$api.district.seriesMedal(this.rankParams)
        if(res.status==0){
          this.medalList=res.data.slice(0, 10)
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 查询精彩集锦
    queryHighlights () {
      this.$api.district.mapdepotList(this.highlightsParams).then(res => {
        if (res.status === 0) {
          res.data.forEach((item, index) => {
            this.highlights[index] = item
          })
        }
      })
    },
    queryBeautiful () {
      this.$api.district.mapdepotList(this.beautifulParams).then(res => {
        if (res.status === 0) {
          this.beautifulList = res.data
        }
      })
    },
    // 跳转到精彩集锦
    wonderfulDetail () {
      localStorage.setItem('menuIndex', 4)
      this.$router.push({
        name: 'WonderfulMoments',
      })
    },
    // 跳转到最美九龙坡
    BeautifulDetail (){
      localStorage.setItem('menuIndex',4)
      this.$router.push({
        name: 'BeautifulJiulong',
      })
    },
    async getSeriesGroup (){
      try {
        let res =await this.$api.district.seriesGroup()
        console.log('getSeriesGroup')
        if(res.status==0){
          this.programAll=res.data
          this.program=res.data[this.tabIndex].matchList
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
  computed: {
    bgColor () {
      let obj={
        backgroundColor:''
      }
      switch(this.tabIndex) {
      case 0:
        obj.backgroundColor='#124584'
        break
      case 1:
        obj.backgroundColor='#028ec8'
        break
      case 2:
        obj.backgroundColor='#ed9a17'
        break
      case 3:
        obj.backgroundColor='#007936'
        break
      default:
        obj.backgroundColor='#124584'
        break
      }
      return obj
    }
  },
  destroyed () {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.bg{
  width: 100%;
  height: 540px;
  background: url('https://static.daoba.com/jlpsport/banner.jpg') no-repeat center center;
}
//竞赛项目
.project{
  width: 100%;
  height: 500px;
  background-color: #124584;
  position: relative;
    .p-left{
      width: 400px;
      height: 500px;
      position: absolute;
      box-sizing: border-box;
      z-index: 99;
      top: 0;
      left: 0;
      padding-top: -20px;
      font-size: 20px;
      color: #FFFFFF;
      .p0{
        width: 400px;
        height: 200px;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        line-height: 200px;
      .square0{
        width: 220px;
        height: 100%;
        background: #124584;
        padding-left: 80px;
          box-sizing: border-box;
        }
        .triangle0{
          width: 0;
          height: 0;
          border-bottom:0 solid transparent;
          border-top:200px solid transparent;
          border-left:60px solid #124584;
          border-right:30px solid transparent;
        }
      }
      .p1{
        width: 400px;
        height: 100px;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        line-height: 100px;
        .square1{
          width: 280px;
          height: 100%;
          background: #028ec8;
          padding-left: 80px;
          box-sizing: border-box;
          }
        .triangle1{
          width: 0;
          height: 0;
          border-bottom:0 solid transparent;
          border-top:100px solid transparent;
          border-left:30px solid #028ec8;
          border-right:30px solid transparent;
        }
      }
      .p2{
        width: 400px;
        height: 100px;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        line-height: 100px;
        .square2{
          width: 310px;
          height: 100%;
          background: #ed9a17;
            padding-left: 80px;
          box-sizing: border-box;
          }
        .triangle2{
          width: 0;
          height: 0;
          border-bottom:0 solid transparent;
          border-top:100px solid transparent;
          border-left:30px solid #ed9a17;
          border-right:30px solid transparent;
        }
      }
      .p3{
        width: 400px;
        height: 100px;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        line-height: 100px;
        .square3{
          width: 370px;
          height: 100%;
          background: #007936;
          padding-left: 80px;
          box-sizing: border-box;
          padding-left: 80px;
          box-sizing: border-box;
        }
        .triangle3{
          width: 0;
          height: 0;
          border-bottom:0 solid transparent;
          border-top:100px solid transparent;
          border-left:30px solid #007936;
          border-right:30px solid transparent;
        }
      }
    }
}
.wonderful{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
  .w-left{
    width: 790px;
    height: 500px;
    margin-right: 10px;
    box-sizing: border-box;
    position: relative;
    img{
      width: 100%;
      height: 100%;
      margin-right: 10px;
    }
    div {
      height: 0px;
      width: 100%;
      background: black;
      position: absolute;
      bottom: 0;
      color:white;
      opacity: 0.6;
      transition: .2s;
      padding: 0px;
    }
  }
  .w-left:hover {
    div {
      height: 100px;
      padding: 5px;
      transition: .2s;
    }
  }
  .w-right{
    width: 400px;
    height: 500px;
    .w-right-item {
      width: 100%;
      position: relative;
      img{
        width: 100%;
        height: 100%;
        margin-right: 10px;
      }
      div {
        height: 0px;
        width: 100%;
        background: black;
        position: absolute;
        bottom: 0;
        color:white;
        opacity: 0.6;
        transition: .2s;
        padding: 0px;
      }
    }
    .w-right-item:hover {
      div {
        height: 80px;
        padding: 5px;
        transition: .2s;
      }
    }
  }
}
.beautiful{
  width: 1200px;
  margin: 0 auto;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  cursor: pointer;
  margin-bottom: 20px;
  .beau-item{
    width: 280px;
    height: 170px;
    margin-bottom: 30px;
    margin-right: 20px;
    box-sizing: border-box;
    img{
      width: 100%;
      height: 100%;
    }
    div {
      height: 0px;
      width: 100%;
      background: black;
      position: absolute;
      bottom: 0;
      color:white;
      opacity: 0.6;
      transition: .2s;
      padding: 0px;
    }
  }
  .beau-item:hover {
    div{
      height: 100%;
      transition: .2s;
      padding: 5px;
    }
  }
  .nomr{
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/district/views/home/Home.vue